module.exports = __webpack_public_path__ + "img/fast-payment-pl.4a471ea0.svg";